import { render, staticRenderFns } from "./TelInput.vue?vue&type=template&id=0d98c31a&scoped=true&"
import script from "./TelInput.vue?vue&type=script&lang=js&"
export * from "./TelInput.vue?vue&type=script&lang=js&"
import style0 from "./TelInput.vue?vue&type=style&index=0&id=0d98c31a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d98c31a",
  null
  
)

export default component.exports